/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MergeAccountsInitDto } from '../../models/merge-accounts-init-dto';
import { MergeAccountsInitResponseDto } from '../../models/merge-accounts-init-response-dto';

export interface MergeAccountsInit$Params {
      body: MergeAccountsInitDto
}

export function mergeAccountsInit(http: HttpClient, rootUrl: string, params: MergeAccountsInit$Params, context?: HttpContext): Observable<StrictHttpResponse<MergeAccountsInitResponseDto>> {
  const rb = new RequestBuilder(rootUrl, mergeAccountsInit.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MergeAccountsInitResponseDto>;
    })
  );
}

mergeAccountsInit.PATH = '/api/v1/customer/merge/init';
